import type {
  ChallengeIdeaFiltersAction,
  ChallengeIdeaFiltersState,
} from "../reducers/challengeIdeaFilters";

type IdeaViewType = ChallengeIdeaFiltersState["ideaViewType"];

const challengeIdeaFiltersActions = {
  UPDATE_CHALLENGE_IDEA_FILTERS: "UPDATE_CHALLENGE_IDEA_FILTERS",
  SET_CHALLENGE_IDEA_VIEW_TYPE: "SET_CHALLENGE_IDEA_VIEW_TYPE",

  update(data: Partial<ChallengeIdeaFiltersState>): ChallengeIdeaFiltersAction {
    return { type: "UPDATE_CHALLENGE_IDEA_FILTERS", data };
  },
  setIdeaViewType(
    ideaViewType: IdeaViewType | string,
  ): ChallengeIdeaFiltersAction {
    return {
      type: "SET_CHALLENGE_IDEA_VIEW_TYPE",
      ideaViewType: ideaViewType as IdeaViewType,
    };
  },
};

export default challengeIdeaFiltersActions;
